module.exports = __webpack_public_path__ + "assets/img/quiz_result@2x.75cf5712.jpg";